import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { _getSubways } from '../../../../shared/helpers/apicalls';
import { _capitalizeText } from '../../../../shared/helpers/utils';
import LinearLoading from '../../../../shared/components/LinearLoading';

const SubwayLines = ({ lines }) => {
	if (!lines || !Array.isArray(lines)) return null;
	return (
		<span>
			{lines.map(line => {
				if (line.toLowerCase().includes('express')) {
					return (
						<span className="subway-line-express" key={line}>
							<span className={`subway-line line-${line.toLowerCase()}`}></span>
							<span className="text">{line.replace(' Express', '')}</span>
						</span>
					);
				}
				return <span className={`subway-line line-${line.toLowerCase()}`} key={line}>{line}</span>;
			})}
		</span>
	);
};

const Transportation = (props) => {
	const { buildingRes } = props;
	const [subways, setSubways] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!buildingRes || !buildingRes.geocode) {
			setLoading(false);
			return;
		}
		let mounted = true;
		const fetchData = async () => {
			const data = await _getSubways(buildingRes);
			if (mounted) {
				setSubways(data);
				setLoading(false);
			}
		};
		fetchData();
		return () => { mounted = false; };
	}, [buildingRes && buildingRes.geocode]);

	if (loading) return <LinearLoading />;

	if (!subways || Object.keys(subways).length === 0) {
		return (
			<Container className="dashboard" style={{ border: "0px solid #DBE0E8" }}>
				<div style={{ fontSize: 12, color: '#999' }}>No subway stations nearby.</div>
			</Container>
		);
	}

	return (
		<Container className="dashboard" style={{ border: "0px solid #DBE0E8" }}>
			<div className="font-weight-bold" style={{ fontSize: 14 }}>Nearby Subways</div>
			<p style={{ fontSize: 12, color: '#999', fontStyle: 'italic' }}>Nearby subway entrances around this building.</p>
			{Object.keys(subways).map((key, i) => {
				const station = subways[key];
				const geoStr = station.geocode ? station.geocode.trim().replace(',', '') : '';
				const formattedGeo = geoStr.slice(geoStr.trim().slice(0, geoStr.indexOf(' ') + ', ' + geoStr.indexOf(' ')));
				const walkTime = Math.round(station.distance * 20);
				return (
					<div key={key + '-' + i} style={{ display: 'flex', alignItems: 'center', padding: '8px 0', fontSize: 12, borderBottom: '1px solid #f0f0f0' }}>
						<div style={{ minWidth: '35%' }}>
							<SubwayLines lines={station.subway_lines} />
						</div>
						<div style={{ minWidth: '40%' }}>
							<a href={`https://www.google.com/maps/place/${formattedGeo}`} target="_blank" rel="noopener noreferrer">
								{_capitalizeText(station.station_name)}
							</a>
						</div>
						<div style={{ textAlign: 'left' }}>
							<span style={{ display: 'inline-block', width: 80 }}>{walkTime} min walk</span>
							<span style={{ color: '#ccc' }}> | </span>
							{station.distance} mi
						</div>
					</div>
				);
			})}
		</Container>
	);
};

export default Transportation;
